<script>
  import MemberUC from '../utility/MemberUC.svelte'
  import MembersSpouseUC from '../utility/MemberSpouseUC.svelte'
  import MembersKidUC from '../utility/MemberKidUC.svelte'
  import MembersSpouse from '../utility/MemberSpouse.svelte'
  import MembersKid from '../utility/MemberKid.svelte'
  import Page from 'page'

  import { api } from '../../store'
  let localapi
  api.subscribe((value) => {
    localapi = value
  })

  let popUpForm = false
  let popUpForm2 = false

  function bringForm() {
    popUpForm = !popUpForm
  }
  function bringForm2() {
    popUpForm2 = !popUpForm2
  }

  let datum
  ;(() => {
    let data = new FormData()
    let loginDatum = JSON.parse(localStorage.getItem('loginData'))
    data.append('email', loginDatum.email)

    let xhttp = new XMLHttpRequest()

    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        // Typical action to be performed when the document is ready:
        let result = JSON.parse(xhttp.responseText)
        if (result) {
          datum = result
        } else {
          datum = false
        }
      }
    }

    xhttp.open('POST', `${localapi}?url=getMember`, true)
    xhttp.setRequestHeader('Authorization', `Bearer ${loginDatum.token}`)
    xhttp.send(data)
  })()
</script>

<div class="minibar">
  <button
    on:click="{() => {
      Page.redirect('/search')
    }}"
    class="btn btn-success">Find Members</button>
  <button on:click="{bringForm}" class="btn btn-success">Add Spouse</button>
  <button on:click="{bringForm2}" class="btn btn-success">Add Kids</button>
  <button
    on:click="{() => {
      Page.redirect('/logout')
    }}"
    class="btn btn-danger">Logout</button>
</div>

{#if popUpForm}
  <div class="float">
    <div class="close mt-5">
      <button on:click="{bringForm}" class="btn btn-danger">Close</button>
    </div>
    <MembersSpouse />
  </div>
{/if}

{#if popUpForm2}
  <div class="float">
    <div class="close mt-5">
      <button on:click="{bringForm2}" class="btn btn-danger">Close</button>
    </div>
    <MembersKid />
  </div>
{/if}

<div class="portal">
  {#if datum}
    {#each datum.member as newMem}
      <MemberUC memberData="{newMem}" />
    {/each}

    {#if Array.isArray(datum.membersSpouse) && datum.membersSpouse.length > 0}
      {#each datum.membersSpouse as newMems}
        <MembersSpouseUC memberData="{newMems}" />
      {/each}
    {/if}
    <div class="kid">
      {#if datum.membersKid.length > 0}
        {#each datum.membersKid as newMem3}
          <MembersKidUC memberData="{newMem3}" />
        {/each}
      {/if}
    </div>
  {/if}
</div>

<style lang="scss">
  .float {
    width: 100vw;
    min-height: 100vh;
    position: absolute;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: rgba(0, 0, 0, 0.315);
  }
  // .minibar {
  //   width: 100vw;
  //   min-height: 10vh;
  //   display: flex;
  //   justify-content: center;
  //   flex-wrap: wrap;

  //   button,
  //   a {
  //     min-width: 150px;
  //     margin: 10px 5px;
  //   }
  // }
  .portal {
    width: 90vw;
    margin: auto;
    display: grid;
    grid-template-columns: 1fr 1fr;

    .kid {
      grid-column: 1 / span 2;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
    }
  }
</style>
